export default __webpack_public_path__ + "static/media/image-gallery-cone.461ff421.jpg";